// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"CSDropdown_dropdown__3IuK8","content":"CSDropdown_content__3Ku13","openContent":"CSDropdown_openContent__2omaG"};